const { log } = require('./log');
const { STATE_NAMES, STATE_NAMES_AU, STATE_NAMES_CA } = require('./constants');

const stateNames = STATE_NAMES;
const auStateNames = STATE_NAMES_AU;
const caStateNames = STATE_NAMES_CA;
module.exports = class Service {
  constructor(store = null, countryCode = null) {
    this.$store = store;
    this.countryCode = countryCode || 'US';
    this.localization = {
      address: {
        zipCode: 'Zipcode',
        state: 'State',
        states: [],
      },
      tempUnit: 'F',
      localTemp: (temp) => temp,
      localDeg: (deg) => deg,
      tempToF: (temp) => temp,
      degToF: (deg) => deg,
      momentLocale: 'en',
      phoneCountryCode: '1',
      locale: 'en',
    };
    this.setLocalization(countryCode);
  }

  setLocalization(override) {
    switch (override || this.countryCode) {
      case 'US':
        // already set to US defaults
        this.localization.address.zipCode = 'Zipcode';
        this.localization.address.state = 'State';
        this.localization.address.states = stateNames;
        this.localization.momentLocal = 'en';
        this.countryCode = 'US';
        this.localization.address.states = stateNames;
        this.localization.tempUnit = 'F';
        this.localization.parsePhone = Service.usPhoneMask;
        this.localization.displayPhone = Service.usDisplayPhone;
        this.localization.phoneCountryCode = '1';
        this.localization.sanitizePhone = (number) => {
          const sanitizedNumber = number.replace(/\D/g, '');
          if (sanitizedNumber.length === 10) {
            return sanitizedNumber;
          }
          return `${sanitizedNumber}0000000000`.substring(0, 10);
        };
        this.localization.localTemp = (temp) => temp;
        this.localization.localDeg = (deg) => deg;
        this.localization.tempToF = (temp) => temp;
        this.localization.degToF = (deg) => deg;

        this.localization.momentLocale = 'en';
        this.localization.datePickerFormat = 'MM/dd/yyyy';
        this.localization.locale = 'en';
        break;
      case 'AU':
        this.countryCode = 'AU';
        this.localization.address.zipCode = 'Postcode';
        this.localization.address.state = 'State/Territory';
        this.localization.address.states = auStateNames;
        this.localization.tempUnit = 'C';
        this.localization.parsePhone = Service.auPhoneMask;
        this.localization.displayPhone = Service.auDisplayPhone;
        this.localization.phoneCountryCode = '61';
        this.localization.sanitizePhone = (number) => {
          let sanitizeNumber = number.replace(/\D/g, '');
          if (sanitizeNumber[0] === '0') {
            sanitizeNumber = sanitizeNumber.slice(1);
          }
          if (sanitizeNumber.length === 9) {
            return sanitizeNumber;
          }
          return `${sanitizeNumber}000000000`.substring(0, 9);
        };
        this.localization.localTemp = Service.fahrenheitToCelsiusTemp;
        this.localization.localDeg = Service.fahrenheitToCelsiusDeg;
        this.localization.tempToF = Service.celsiusToFahrenheitTemp;
        this.localization.degToF = Service.celsiusToFahrenheitDeg;

        this.localization.momentLocale = 'en-au';
        this.localization.datePickerFormat = 'dd/MM/yyyy';
        this.localization.locale = 'en-au';
        break;
      case 'CA':
        this.countryCode = 'CA';
        this.localization.address.zipCode = 'Postal Code';
        this.localization.address.state = 'Province';
        this.localization.address.states = caStateNames;
        this.localization.tempUnit = 'C';
        this.localization.parsePhone = Service.usPhoneMask;
        this.localization.displayPhone = Service.usDisplayPhone;
        this.localization.phoneCountryCode = '1';
        this.localization.sanitizePhone = (number) => {
          const sanitizedNumber = number.replace(/\D/g, '');
          if (sanitizedNumber.length === 10) {
            return sanitizedNumber;
          }
          return `${sanitizedNumber}0000000000`.substring(0, 10);
        };
        this.localization.localTemp = Service.fahrenheitToCelsiusTemp;
        this.localization.localDeg = Service.fahrenheitToCelsiusDeg;
        this.localization.tempToF = Service.celsiusToFahrenheitTemp;
        this.localization.degToF = Service.celsiusToFahrenheitDeg;

        this.localization.momentLocale = 'en-ca';
        this.localization.datePickerFormat = 'MM/dd/yyyy';
        this.localization.locale = 'en-ca';
        break;
      default:
        break;
    }
    return this.localization;
  }

  static auPhoneMask(number) {
    let isValid = false;
    let invalidMsg = '';
    if (!number) { return { number, isValid, invalidMsg }; }
    if (number[0] !== '0') {
      invalidMsg = 'Phone number must start with zero';
      return { formattedNumber: '', isValid, invalidMsg };
    }
    const digitsOnly = number.replace(/\D/g, '');
    const maskedNumber = `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7, 10)}`;
    // this split and re-join supports enables deleting spaces naturally
    const sections = maskedNumber.split(' ');
    const reconstructedNumber = sections.filter((n) => n || n.length > 0).join(' ');

    if (digitsOnly.length < 10) {
      invalidMsg = 'Phone number must be 10 digits long';
    } else {
      isValid = true;
    }
    return { formattedNumber: reconstructedNumber, isValid, invalidMsg };
  }

  static auDisplayPhone(phoneFromDb) {
    if (phoneFromDb.length === 9) {
      const maskedNumber = `0${phoneFromDb.slice(0, 3)} ${phoneFromDb.slice(3, 6)} ${phoneFromDb.slice(6, 9)}`;
      return maskedNumber;
    }
    if (phoneFromDb) {
      log.error('Phone number from API does not match expected format, displaying as-is');
    }
    return phoneFromDb;
  }

  static usPhoneMask(number) {
    let isValid = false;
    let invalidMsg = '';
    if (!number) { return { number, isValid, invalidMsg }; }

    const digitsOnly = number.replace(/\D/g, '');

    let areaCode = digitsOnly.slice(0, 3);
    let middleBlock = digitsOnly.slice(3, 6);
    const lastBlock = digitsOnly.slice(6, 10);

    if (areaCode) {
      if (areaCode.length < 3) {
        areaCode = `(${areaCode}`;
      } else if (number[4] !== ')' && !middleBlock) {
        areaCode = `(${areaCode}`;
      } else {
        areaCode = `(${areaCode})`;
      }
    }

    if (middleBlock) {
      if (middleBlock.length <= 3 && !lastBlock) {
        if (number[9] !== '-') {
          middleBlock = `${middleBlock}`;
        }
      } else {
        middleBlock = `${middleBlock}-`;
      }
    }

    const areaPlusMiddle = [areaCode, middleBlock].filter((n) => n).join(' ');
    const fullNumber = [areaPlusMiddle, lastBlock].filter((n) => n).join('');
    const reconstructedNumber = fullNumber;
    if (digitsOnly.length < 10) {
      invalidMsg = 'Phone number must be 10 digits long';
    } else {
      isValid = true;
    }
    return { formattedNumber: reconstructedNumber, isValid, invalidMsg };
  }

  static usDisplayPhone(phoneFromDb) {
    if (phoneFromDb.length === 10) {
      const maskedNumber = `(${phoneFromDb.slice(0, 3)}) ${phoneFromDb.slice(3, 6)}-${phoneFromDb.slice(6, 10)}`;
      return maskedNumber;
    }
    log.error('Phone number from API does not match expected format, displaying without formatting');
    return phoneFromDb;
  }

  static fahrenheitToCelsiusTemp(tempF, precise = false) {
    // precise = true is used to maintain accuracy of graphed data and avoid large steps between whole numbers
    // toPrecision avoids the value being returned as temp.0000000000000001
    if (tempF == null) {
      return null;
    }
    return precise ? ((5 / 9) * (tempF - 32)) : parseInt(((5 / 9) * (tempF - 32)).toPrecision(4), 10);
  }

  static fahrenheitToCelsiusDeg(degreesF) {
    if (degreesF == null) {
      return null;
    }
    return parseInt((degreesF * (5 / 9)).toPrecision(4), 10);
  }

  static celsiusToFahrenheitTemp(tempC) {
    if (tempC == null) {
      return null;
    }
    return (tempC * (9 / 5)) + 32;
  }

  static celsiusToFahrenheitDeg(degreesC) {
    if (degreesC == null) {
      return null;
    }
    return degreesC * (9 / 5);
  }
};
